import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from "@angular/flex-layout";
import {ReactiveFormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { ONasComponent } from './o-nas/o-nas.component';
import { GaleriaComponent } from './galeria/galeria.component';
import { KontaktComponent } from './kontakt/kontakt.component';
import { FooterComponent } from './footer/footer.component';

import {MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatGridListModule,
        MatCardModule,
        MatListModule,
        MatDividerModule,
        MatFormFieldModule,
        MatTabsModule,
        MatInputModule
        } from '@angular/material';


import {MenubarModule} from 'primeng/menubar';
import {CardModule} from 'primeng/card';
import { BrandbarComponent } from './brandbar/brandbar.component';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG, BrowserTransferStateModule } from '@angular/platform-browser';
import 'hammerjs';
import { NgxGalleryModule } from 'ngx-gallery';
import { AppModule } from './app.module';


export class CustomHammerConfig extends HammerGestureConfig  {
   overrides = {
       pinch: { enable: false },
       rotate: { enable: false }
   };
}

@NgModule({
  imports: [

    
    BrowserAnimationsModule,
    AppRoutingModule,
    CardModule,
    MenubarModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    MatCardModule,
    FlexLayoutModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,ReactiveFormsModule,MatTabsModule,
    MatDividerModule,
    NgxGalleryModule,
    AppModule,
    BrowserTransferStateModule
  ],
  providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig }],
  bootstrap: [AppComponent]
})
export class AppBrowserModule { }
